import { render, staticRenderFns } from "./PakkumiseQR.vue?vue&type=template&id=24e58626"
import script from "./PakkumiseQR.vue?vue&type=script&lang=js"
export * from "./PakkumiseQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports